import {
  Box,
  Button,
  HStack,
  VStack,
  Heading,
  Text,
  Container,
} from "@chakra-ui/react";
import useGoldlistMint from "hooks/useGoldlistMint";
import useTranslate from "hooks/useTranslate";
import { useCallback, useMemo } from "react";
import useAssets from "hooks/useAssets";
import useConnectedAccount from "hooks/useConnectedAccount";

const GoldlistContainer = () => {
  const translate = useTranslate();
  const [address] = useConnectedAccount();

  const {
    goldlistClaimedCount,
    goldlistMaxClaim,
    readGoldlistClaimedCount,
    readHoneyJarsInWallet,
  } = useAssets();

  const availableToClaim = useMemo(() => {
    if (goldlistMaxClaim && goldlistClaimedCount !== undefined) {
      return goldlistMaxClaim - goldlistClaimedCount;
    }
  }, [goldlistMaxClaim, goldlistClaimedCount]);

  const handleMintGoldlistSuccess = useCallback(() => {
    readGoldlistClaimedCount();
    readHoneyJarsInWallet();
  }, [readGoldlistClaimedCount, readHoneyJarsInWallet]);

  const [mintGoldlist, isGoldlistMinting] = useGoldlistMint(
    address,
    availableToClaim,
    goldlistMaxClaim,
    handleMintGoldlistSuccess
  );

  const handleClaim = useCallback(() => {
    mintGoldlist();
  }, [mintGoldlist]);

  return !!availableToClaim ? (
    <Container
      marginTop={{
        base: "-12",
        sm: "0",
      }}
      paddingX={{
        base: "0",
        sm: "6",
      }}
    >
      <Box bg="secondary.500" py="5" px="6" w="full">
        <HStack gap="2" align="center" justify="stretch">
          <VStack w="full" align="start" spacing="0.5">
            <Heading fontSize="2xl" fontWeight="800">
              {translate("goldlist:title")}
            </Heading>
            <Text>{translate("goldlist:description")}</Text>
          </VStack>

          <Button onClick={handleClaim} isLoading={isGoldlistMinting}>
            {availableToClaim
              ? availableToClaim > 1
                ? translate("common:claim:multi", { count: availableToClaim })
                : translate("common:claim:one")
              : translate("common:claim:none")}
          </Button>
        </HStack>
      </Box>
    </Container>
  ) : null;
};

export default GoldlistContainer;
